import { Component } from '@angular/core'
import { IHeaderParams } from 'ag-grid-community'
import { IHeaderAngularComp } from 'ag-grid-angular'
import { MatIcon } from '@angular/material/icon'
import { SortDirection } from '../shared/utilities/http-params'
import { IdrTableHeaderMenuComponent } from './idr-table-header-menu.component'
import { SortEvent } from '../public/table/services/table-sort.service'

export type IdrTableHeaderMenuItem = Readonly<{
  id: string
  label: string
  separator?: boolean
  click: () => void
  disabled?: boolean
}>

export type IdrTableHeaderMenu = Readonly<{
  items: readonly IdrTableHeaderMenuItem[]
}>

export type IdrTableHeaderParams = Readonly<{
  filtered: boolean
  sortDirection?: SortDirection
  menu: IdrTableHeaderMenu
  onSortChange: (event: SortEvent) => void
}>

const defaultParams: IdrTableHeaderParams = {
  filtered: false,
  menu: { items: [] },
  onSortChange: () => { /* empty */ },
}

@Component({
  imports: [MatIcon, IdrTableHeaderMenuComponent],
  selector: 'app-idr-table-header',
  template: `
    <button class='sort' (click)="handleSortChange($event)">
      <span class='header-name'>{{ headerName }}</span>
      @if (params.sortDirection) {
        <span class='sort-indicator'>
          <mat-icon [svgIcon]="sortIconName()" />  
        </span>
      }
    </button>
    <app-idr-table-header-menu [menu]="params.menu" [filtered]="params.filtered" />
  `,
  styles: `
    :host {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      font-size: 1rem;
    }
    
    button.sort {
      display: flex;
      flex-basis: 0;
      flex-grow: 1;
      background-color: transparent;
      border: none;
      padding: 0;
      .header-name {
        flex-basis: 0;
        flex-grow: 1;
        white-space: break-spaces;
        text-align: start;
        text-overflow: ellipsis;
        overflow: hidden;
        max-height: 2.5rem;
        line-height: 1.2rem;
      }
      
      .sort-indicator {
        position: relative;
        width: 1.5rem;
        height: 1.5rem;
        .mat-icon {
          transform: scale(0.75);
        }
      }
    }
    
    app-idr-table-header-menu {
      padding-top: 13px;
      height: 100%;
    }
  `,
})
export class IdrDataTableHeaderComponent implements IHeaderAngularComp {
  protected field = ''
  protected headerName = ''
  protected params: IdrTableHeaderParams = defaultParams

  protected sortIconName(): string {
    return this.params.sortDirection === 'asc' ? 'sort_asc' : 'sort_desc'
  }

  agInit(params: IHeaderParams): void {
    this.refresh(params)
  }

  protected handleSortChange(event: MouseEvent) {
    this.params.onSortChange({ name: this.field, multi: event.ctrlKey })
  }

  refresh({ column }: IHeaderParams): boolean {
    this.field = column.getColDef().field ?? ''
    this.headerName = column.getColDef().headerName ?? ''
    this.params = column.getColDef().headerComponentParams
    return true
  }
}
